module.exports = function() {
  return new Worker(__webpack_public_path__ + "cf0f835af98c51c18d55.worker.js");
};